import { useMemo } from 'react';
import { InvoiceDetailsResponse } from 'src/services/useInvoiceDetailsApi';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import { round } from 'src/utils/number';

const useInvoiceWarnings = (
  invoice: InvoiceDetailsResponse,
  totalsGlCodeItem: InvoiceGlBreakoutItem,
  isLoading: boolean
) => {
  const discountAmt = useMemo(() => {
    let warnings: string[] = [];
    if (
      invoice?.discountAmt !== undefined &&
      totalsGlCodeItem?.discountAmt !== undefined &&
      round(totalsGlCodeItem?.discountAmt, 2) !== round(Number(invoice?.discountAmt), 2) &&
      !invoice?.isAutoDistGlBreakout
    ) {
      warnings = ['Discount total mismatch.'];
    }

    return warnings;
  }, [invoice?.discountAmt, invoice?.isAutoDistGlBreakout, totalsGlCodeItem?.discountAmt]);

  const salesTaxAmt = useMemo(() => {
    let warnings: string[] = [];
    if (
      totalsGlCodeItem?.salesTaxAmt !== undefined &&
      invoice?.salesTaxAmt !== undefined &&
      round(totalsGlCodeItem?.salesTaxAmt, 2) !== round(Number(invoice?.salesTaxAmt), 2)
    )
      warnings = ['Sales tax mismatch.'];
    return warnings;
  }, [invoice?.salesTaxAmt, totalsGlCodeItem?.salesTaxAmt]);

  const shipCostAmt = useMemo(() => {
    let warnings: string[] = [];
    if (
      totalsGlCodeItem?.shipCostAmt !== undefined &&
      invoice?.shipCostAmt !== undefined &&
      round(totalsGlCodeItem?.shipCostAmt, 2) !== round(Number(invoice?.shipCostAmt), 2) &&
      !invoice?.isAutoDistGlBreakout
    )
      warnings = ['Shipping cost mismatch.'];

    return warnings;
  }, [invoice?.isAutoDistGlBreakout, invoice?.shipCostAmt, totalsGlCodeItem?.shipCostAmt]);

  const totalCostAmt = useMemo(() => {
    let warnings: string[] = [];
    if (isLoading) return [];
    if (
      totalsGlCodeItem?.glTotal !== undefined &&
      round(totalsGlCodeItem?.glTotal, 2) !== (Number(invoice?.totalCostAmt) || 0)
    ) {
      warnings = ['Grand total mismatch.'];
    }

    return warnings;
  }, [invoice?.totalCostAmt, isLoading, totalsGlCodeItem?.glTotal]);

  return { discountAmt, salesTaxAmt, shipCostAmt, totalCostAmt };
};

export default useInvoiceWarnings;
